import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { umsUrl } from '../../../../Containers/Config/index.js';
import { VENDOR_LOGIN_V2, VENDOR_LOGIN_V2_SUCCESS, VENDOR_LOGIN_V2_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';

function* vendorLoginV2({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/vendor-login`,
      method: 'POST',
      data: payload?.data,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 200) {
      yield put({ type: VENDOR_LOGIN_V2_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: VENDOR_LOGIN_V2_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: VENDOR_LOGIN_V2_ERROR, payload: error });
  }
}

export function* watchvendorLoginV2() {
  yield takeEvery(VENDOR_LOGIN_V2, vendorLoginV2);
}

function* vendorLoginV2Saga() {
  yield all([fork(watchvendorLoginV2)]);
}

export default vendorLoginV2Saga;
